import { COUNTRY_FRAGMENT } from '@app/model/refdata/service/RefDataGraphqlFragments';
import { gql } from 'graphql-request';

export const ROOM_FRAGMENT = gql`
    fragment RoomFields on Room {
        id
        name
        beds
        facilities
        capacity
        sqm
        maxPersons
        medianPrice
        numberOfBedrooms
        numberOfBathrooms
        numberOfBeds
    }
`
export const ROOM_MAPPING_FRAGMENT = gql`
    fragment HotelRoomWithMappingFields on HotelRoomWithMapping {
        provider
        roomId
        roomName
        roomIsActive
        roomIsPartnerOffer
        capacity
        maxPersons
        medianPrice
        rankIndex
        roomMappingName
        roomMappingType
        sqm
        view
        numberOfBedrooms
        numberOfBathrooms
        numberOfBeds
    }
`

export const BASIC_HOTEL_FRAGMENT = gql`
    ${COUNTRY_FRAGMENT}
    fragment BasicHotelFields on Hotel {
        id
        name
        rating
        ratingType
        location {
            country {
                ...CountryFields
            }
            address
            city
            coordinates {
                lat
                lng
            }
        }
    }
`
export const HOTEL_FRAGMENT = gql`
    ${ROOM_FRAGMENT}
    ${BASIC_HOTEL_FRAGMENT}
    fragment HotelFields on Hotel {
        ...BasicHotelFields
        isSuperhost
        imageUrl
        ratingType
        rating
        bookingUrl
        reviewScore {
            average
            location
            cleanliness
            facilities
            staff
            valueForMoney
            wifi
            sum
        }
        rooms{
            ...RoomFields
        }
    }
`